import { useLocation } from "react-router-dom";
import { history } from "../_helpers";
import ErrorImg from "../assets/errorPage.png";
function Error() {
  const location = useLocation();
  const pathList = location?.pathname.split("/");
  return (
    <section className="sign-in-section">
      <div className="container error-page-box">
        <div className="p-5 d-flex flex-column justify-content-center align-items-center">
          <img src={ErrorImg} alt="404" />
          <h2 className="error-page-label">Oops! Page not Found</h2>
          {!pathList?.includes("Admin") && (
            <button
              onClick={() => {
                history?.navigate("/Home");
              }}
              type="submit"
              className="sign-in-button"
            >
              Back to Home
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default Error;
